<template>
    <div class="">
        <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item"><router-link to="/users">Users</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">
                        <span v-if="status">New User</span>
                        <span v-else>Update User</span>
                    </li>
                </ol>
                <label class="form-label">
                    <h4 v-if="status">New User</h4>
                    <h4 v-else>Update User</h4>
                </label>
            </div>
            <router-link to="/users" type="submit" class="btn d-flex align-item-center btn-primary"><i class="ri-list-check me-1"></i> USERS</router-link>
        </div>
        <form @submit.prevent="submitForm">
            <div class="card card-shadow br-16">
                <div class="card-body mb-3">
                    <div class="row g-3">
                        <div class="col-md-4">
                            <label class="form-label">Employee Id</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Employee Id" class="form-control" :class="{ 'is-invalid': errors.employee_id }" v-model="user.employee_id" ref="employee_id" />
                            <span v-if="errors.employee_id" class="invalid-feedback">{{ errors.employee_id }}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Name</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Name" class="form-control" :class="{ 'is-invalid': errors.name }" v-model="user.name" ref="name" />
                            <span v-if="errors.name" class="invalid-feedback">{{ errors.name }}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Email</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Email" class="form-control" :class="{ 'is-invalid': errors.email }" v-model="user.email" />
                            <span v-if="errors.email" class="invalid-feedback">{{ errors.email}}</span>
                        </div>
                        <div class="col-md-4" v-if="status">
                            <label class="form-label">Password</label><span class="text-danger"> *</span>
                            <input :disabled="!status" type="password" placeholder="Password" class="form-control" :class="{ 'is-invalid': errors.password }" v-model="user.password" />
                            <span v-if="errors.password" class="invalid-feedback">{{ errors.password }}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Role</label><span class="text-danger"> *</span>
                            <select class="form-control" :class="{ 'is-invalid': errors.role }" v-model="user.role">
                                <option value="">Select Role</option>
                                <option value="Admin">Admin</option>
                                <option value="User">User</option>
                            </select>
                            <span v-if="errors.role" class="invalid-feedback">{{ errors.role }}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Mobile No.</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Mobile No." class="form-control" :class="{ 'is-invalid': errors.mobile_no }" v-model="user.mobile_no" />
                            <span v-if="errors.mobile_no" class="invalid-feedback">{{ errors.mobile_no}}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Assign Districts</label>
                            <MultiSelect
                                v-model="district_ids"
                                filter
                                optionLabel="district"
                                :options="districts"
                                placeholder="Select District"
                                :maxSelectedLabels="3"
                                style="width: 100%; height: 37px;"
                                :style="errors?.district_id ? error_style : ''"
                            />
                        </div>
                        <div class="col-md-12">
                            <div class="text-end">
                                <button type="reset" class="btn btn-danger me-2" @click.prevent="discard()"><i class="ri-close-line icon_hgt"></i> DISCARD</button>
                                <button v-if="status" type="submit" class="btn btn-primary"><i class="ri-save-line icon_hgt"></i> SUBMIT</button>
                                <button v-else type="submit" class="btn btn-primary"><i class="ri-save-line icon_hgt"></i> UPDATE</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    import MultiSelect from "primevue/multiselect";
    export default {
        name: "Users.Create",
        components: { MultiSelect },
        data() {
            return {
                user: {
                    user_id: "",
                    employee_id: "",
                    name: "",
                    email: "",
                    password: "",
                    mobile_no: "",
                    role: "",
                },
                status: true,
                users: [],
                errors: [],
                districts: [],
                district_ids: [],
                district_user: {
                    user_id: "",
                    district_ids: [],
                    deleted_district_ids: [],
                },
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getDistrict();
                vm.district_user.user_id = to.params.user_id;
                if (to.name == "Users.Create") {
                    vm.$refs.employee_id.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "users/viewUser", data: { user_id: to.params.user_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.user = response.data.data;
                            vm.district_ids = [];
                            for (let i = 0; i < vm.user.DistrictUsers.length; i++) {
                                vm.district_ids.push({
                                    district_id: vm.user.DistrictUsers[i].district_id,
                                    district: vm.user.DistrictUsers[i].District.district,
                                });
                            }
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },
        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.create();
                } else {
                    vm.update();
                }
            },
            getDistrict() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "district/getDistricts" })
                    .then((response) => {
                        loader.hide();
                        vm.districts = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            create() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "users/addUser", data: vm.user };
                vm.$store
                    .dispatch("post", uri)
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "User is successfully created");
                        // console.log('vm.district_ids:-----', vm.district_ids.length)
                        // console.log('vm.user_date:-----', response.data.data['user_id']);
                        vm.district_user.user_id = response.data.data.user_id;
                        if (vm.district_ids.length > 0) {
                            vm.submitdistricts();
                        } else {
                            vm.$router.push("/users");
                        }
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            update() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "users/updateUser", data: vm.user };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "User is successfully updated");
                        if (vm.district_ids.length > 0) {
                            vm.submitdistricts();
                        } else {
                            vm.$router.push("/users");
                        }
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            submitdistricts() {
                let vm = this;
                let loader = vm.$loading.show();

                for (let i = 0; i < vm.district_ids.length; i++) {
                    vm.district_user.district_ids.push(vm.district_ids[i].district_id);
                }

                const districtIds = vm.district_ids?.map((ele) => ele.district_id);
                const userdistrictIds = vm.user?.DistrictUsers?.map((ele) => ele.district_id);
                vm.district_user.deleted_district_ids = userdistrictIds?.filter((item) => !districtIds?.includes(item));

                let uri = { uri: "districtUsers/addMultipleDistrictUsers", data: vm.district_user };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        // vm.$store.dispatch("success", "District is successfully created");
                        vm.discard();
                        vm.$router.push("/users");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            discard() {
                let vm = this;
                (vm.user.employee_id = ""), (vm.user.name = "");
                vm.user.email = "";
                vm.user.password = "";
                vm.user.mobile_no = "";
                vm.user.role = "";
                vm.$refs.employee_id.focus();
                vm.errors = [];
                vm.status = true;
            },
        },
    };
</script>
